import { render, staticRenderFns } from "./processed_image.vue?vue&type=template&id=a246b8e4&"
import script from "./processed_image.vue?vue&type=script&lang=js&"
export * from "./processed_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports